import { combineReducers } from 'redux';
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import login from './login/Reducers';
import invite from './invite/Reducers';
import group from './group/Reducers';
import template from './template/Reducers';
import user from './user/Reducers';
import evaluation from './evaluation/Reducers';
import quiz from './quiz/Reducers';
import plan from './plan/Reducers';

const loginConfig = {
	key: 'login',
	storage,
	whitelist: ["email", "password", "scope"]
};

export const Reducers = combineReducers({
	login: persistReducer(loginConfig, login),
	invite,
	group,
	template,
	user,
	evaluation,
	quiz,
	plan
})